import { render } from "./DetailTravel.vue?vue&type=template&id=97749d44"
import script from "./DetailTravel.vue?vue&type=script&lang=js"
export * from "./DetailTravel.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./DetailTravel.vue?vue&type=style&index=1&id=97749d44&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__